export const BLOCK_COLOR_OPTIONS = [
  {
    id: 'orange',
    label: 'Orange',
    background: 'rgba(204, 82, 0, 0.3)',
    border: '#CC5200',
    accent: '#CC5200',
    text: '#444444',
  },
  {
    id: 'red',
    label: 'Red',
    background: 'rgba(255, 55, 55, 0.3)',
    border: '#FF3737',
    accent: '#FF3737',
    text: '#444444',
  },
  {
    id: 'peach',
    label: 'Peach',
    background: 'rgba(255, 133, 51, 0.3)',
    border: '#FF8533',
    accent: '#FF8533',
    text: '#444444',
  },
  {
    id: 'yellow',
    label: 'Yellow',
    background: 'rgba(255, 203, 71, 0.3)',
    border: '#FFCB47',
    accent: '#FFCB47',
    text: '#444444',
  },
  {
    id: 'green',
    label: 'Green',
    background: 'rgba(13, 204, 138, 0.3)',
    border: '#0DCC8A',
    accent: '#0DCC8A',
    text: '#444444',
  },
  {
    id: 'lime',
    label: 'Lime',
    background: 'rgba(150, 190, 79, 0.3)',
    border: '#96BE4F',
    accent: '#96BE4F',
    text: '#444444',
  },
  {
    id: 'lightblue',
    label: 'Light Blue',
    background: 'rgba(169, 200, 255, 0.3)',
    border: '#A9C8FF',
    accent: '#A9C8FF',
    text: '#444444',
  },
  {
    id: 'blue',
    label: 'Blue',
    background: 'rgba(0, 90, 255, 0.3)',
    border: '#005AFF',
    accent: '#005AFF',
    text: '#444444',
  },
  {
    id: 'cyan',
    label: 'Cyan',
    background: 'rgba(0, 229, 255, 0.3)',
    border: '#00E5FF',
    accent: '#00E5FF',
    text: '#444444',
  },
  {
    id: 'purple',
    label: 'Purple',
    background: 'rgba(100, 65, 165, 0.3)',
    border: '#6441A5',
    accent: '#6441A5',
    text: '#444444',
  },
  {
    id: 'magenta',
    label: 'Magenta',
    background: 'rgba(255, 0, 191, 0.3)',
    border: '#FF00BF',
    accent: '#FF00BF',
    text: '#444444',
  },
  {
    id: 'white',
    label: 'White',
    background: 'rgba(224, 224, 224, 0.3)',
    border: '#E0E0E0',
    accent: '#E0E0E0',
    text: '#444444',
  },
];

const DEFAULT_BLOCK_COLOR_ID = 'lightblue';

const optionById = BLOCK_COLOR_OPTIONS.reduce(
  (acc, option) => ({
    ...acc,
    [option.id]: option,
  }),
  {},
);

const FALLBACK_SEQUENCE = BLOCK_COLOR_OPTIONS.map((option) => option.id);

export const getColorOptionForBlock = (block) => {
  if (!block) {
    return optionById[DEFAULT_BLOCK_COLOR_ID];
  }

  // Check if it's a preset color
  if (block.colorId && optionById[block.colorId]) {
    return optionById[block.colorId];
  }

  // Fallback: use block ID to deterministically pick a color
  const blockId = block.id || '';
  if (!blockId) {
    return optionById[DEFAULT_BLOCK_COLOR_ID];
  }

  let hash = 0;
  for (let i = 0; i < blockId.length; i += 1) {
    hash = (hash * 31 + blockId.charCodeAt(i)) % 2147483647;
  }

  const fallbackId = FALLBACK_SEQUENCE[Math.abs(hash) % FALLBACK_SEQUENCE.length]
    || DEFAULT_BLOCK_COLOR_ID;

  return optionById[fallbackId];
};

/**
 * Convert color ID to hex color for API
 * @param {string} colorId - Color ID like 'lightblue'
 * @returns {string} - Hex color string
 */
export const colorIdToHex = (colorId) => {
  const defaultAccent = optionById[DEFAULT_BLOCK_COLOR_ID].accent;

  if (!colorId) {
    return defaultAccent;
  }

  // If it's a preset color ID, return its accent color
  const colorOption = optionById[colorId];
  if (colorOption) {
    return colorOption.accent;
  }

  // Fallback to default
  return defaultAccent;
};

/**
 * Convert hex color from API to color ID for frontend
 * @param {string} hexColor - Hex color string from API
 * @returns {string} - Color ID (defaults to lightblue if no match)
 */
export const hexToColorId = (hexColor) => {
  if (!hexColor) {
    return DEFAULT_BLOCK_COLOR_ID;
  }

  const normalizedHex = hexColor.toUpperCase();

  // Check if it matches any preset color's accent
  const matchingOption = BLOCK_COLOR_OPTIONS.find(
    (option) => option.accent.toUpperCase() === normalizedHex,
  );

  if (matchingOption) {
    return matchingOption.id;
  }

  // Fallback to default if no match found
  return DEFAULT_BLOCK_COLOR_ID;
};
